import { createFileRoute, redirect } from "@tanstack/react-router";
const SLUG = "storm-damage-roof-repair-phoenix";
export const Route = createFileRoute("/storm-damage-roof-repair-phoenix")({
  beforeLoad: () => { throw redirect({ to: "/blog/$slug", params: { slug: SLUG }, statusCode: 301 }); },
});
